import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavListCommonProps } from 'src/app/components/nav/nav.component';
import { environment } from 'src/environments/environment';
import { FunctionalityCode } from '../_enums/functionality.code';
import { GroupBy } from '../_enums/groupby';
import { SiteMapUrl } from '../_enums/sitemap.url';
import { Agency } from '../_models/agency';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AgencyService {
  constructor(
    private readonly http: HttpClient,
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly translate: TranslateService
  ) {}

  get(agencyId: string) {
    return this.http.get<Agency>(`${environment.apiUrl}/Agencies/${agencyId}`, { headers: this.authService.headers });
  }

  getAll(groupBy?: string) {
    let params = new HttpParams();
    params = groupBy ? params.set('groupBy', groupBy) : params;

    return this.http.get<Agency[]>(`${environment.apiUrl}/Agencies`, { params: params, headers: this.authService.headers });
  }

  update(agency: Agency) {
    return this.http.put<Agency>(`${environment.apiUrl}/Agencies/${agency.agencyId}`, agency, { headers: this.authService.headers });
  }

  add(agency: Agency) {
    return this.http.post<Agency>(`${environment.apiUrl}/Agencies`, agency, { headers: this.authService.headers });
  }

  delete(agencyId: string) {
    return this.http.delete(`${environment.apiUrl}/Agencies/${agencyId}`, { headers: this.authService.headers });
  }

  duplicate(agencyId: string) {
    return this.http.post(`${environment.apiUrl}/Agencies/duplicate?id=${agencyId}}`, null, { headers: this.authService.headers });
  }

  getNavConfig({ perimeterId }: NavListCommonProps) {
    let manageAgency = false;
    if (this.authService?.accessesValues) manageAgency = this.authService.accessesValues.includes(FunctionalityCode.ManageAgency);
    return {
      header: {
        title: 'ressource_list_title_agencies',
        actions: manageAgency
          ? [
              {
                label: 'ressource_list_action_add',
                onClick: () => {
                  this.router.navigate([`${SiteMapUrl.MenuOrganisation}/new`, 0], { state: { perimeterId } });
                }
              }
            ]
          : [],
        filters: [],
        defaultFilter: GroupBy.family
      },
      getDataSource: this.getAll.bind(this),
      getItemConfig: (node: any) => {
        return {
          displayName: `${node.displayName} [${node.code}]`,
          url: `${SiteMapUrl.MenuOrganisation}/${node.agencyId}`,
          state: {
            agencyId: node.agencyId,
            perimeterId
          }
        };
      }
    };
  }
}
